import { Box, lighten, Typography } from "@mui/material";
import { formatToNA } from "./Formatter";
import { grey } from "@mui/material/colors";

export default function DataLabel({ ...props }) {
    const { value, label, actions, noWrap, bottom = false, align, ...others } = props;
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row' }} {...others}>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                {bottom &&
                    <>
                        <Typography component="div" noWrap={noWrap} align={align}>
                            {formatToNA(value)}
                        </Typography>
                        <Typography sx={{ color: lighten(grey[700], 0.2) }} variant="body2" align={align}>
                            {label}
                        </Typography>
                    </>}
                {!bottom &&
                    <>
                        <Typography sx={{ color: lighten(grey[700], 0.2) }} variant="body2" align={align}>
                            {label}
                        </Typography>
                        <Typography component="div" noWrap={noWrap} align={align}>
                            {formatToNA(value)}
                        </Typography>

                    </>}
            </Box>
            {actions &&
                <Box>
                    {actions}
                </Box>
            }
        </Box>)
}